import { Field, FormikProps } from 'formik'
import React, { useState } from 'react'
import styled from 'styled-components'

interface IRadioButton {
	name: string
	groupLabel?: string
	values: string[]
	isRequired?: boolean
	disclaimerRefrence?: boolean
	formikProps: FormikProps<any>
}

const RadioButtons = ({
	name,
	groupLabel,
	values,
	isRequired = false,
	disclaimerRefrence = false,
	formikProps,
}: IRadioButton) => {
	const [isClicked, setIsClicked] = useState(-1)

	if (formikProps.values[name] === '' && isClicked !== -1) {
		setIsClicked(-1)
	}

	return (
		<>
			{groupLabel && (
				<GroupName>
					<h5>{groupLabel}</h5>
					{isRequired && <Red>*</Red>}
				</GroupName>
			)}
			{values.map((value, index) => {
				const isChecked = isClicked === index
				return (
					<Label
						isClicked={isChecked}
						key={index}
						onClick={(e) => e.preventDefault()}
					>
						<RadioField
							type='radio'
							name={name}
							value={value}
						/>
						<RadioMarkDiv
							isClicked={isClicked === index}
							onClick={() => {
								setIsClicked(index)
								formikProps.setFieldValue(name, value, false)
							}}
						>
							{isChecked && <RadioMark />}
						</RadioMarkDiv>

						{value}
						{disclaimerRefrence && '*'.repeat(index + 1)}
					</Label>
				)
			})}
		</>
	)
}

const Red = styled.h5`
	color: var(--orange);
`
const GroupName = styled.div`
	display: flex;
	align-items: center;
	margin-top: 16px;
	gap: 5px;

	h5 {
		margin: 0;
	}
`

const RadioMark = styled.div`
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #08576f;
`

const RadioMarkDiv = styled.div<{ isClicked: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	cursor: pointer;

	background-color: ${(props) => (props.isClicked ? 'var(--baby-blue)' : 'var(--off-white)')};
`

const RadioField = styled(Field)`
	display: none;
	width: 24px;
	height: 24px;
`
const Label = styled.label<{ isClicked: boolean }>`
	${(props) => props.isClicked && 'background-color: white'};
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px;
	gap: 8px;
	border-radius: 8px;
	width: fit-content;
`

export default RadioButtons
